<template>
	<div
		class="img-container"
		:class="content.position"
	>
		<NuxtImg
			v-for="item in content.options"
			:alt="item.alt"
			:style="{ height: item.iconHeight + 'px' }"
			:key="item.alt"
			:src="item.icon"
			:height="item.iconHeight"
		/>
	</div>
</template>
<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
export default defineNuxtComponent({
	name: "ECommerceOptionsIcons",
	mixins: [GizmoComponentMixin],
});
</script>

<style lang="scss" scoped>
.img-container {
	padding-left: $spacing-s;
	display: flex;
	gap: $spacing-m;
	align-items: center;
}

.left {
	justify-content: flex-start;
}

.right {
	justify-content: flex-end;
}

.center {
	justify-content: center;
}
</style>
